module.exports = __webpack_public_path__ + "media/images/icons/country_flags/um-9efb46d30197d66c362f230fd70b6ee9.svg";